import { render } from "./JoinPublicationCompleteAccount.vue.js?vue&type=template&id=cf938ebc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationCompleteAccount.vue?vue&type=template&id=cf938ebc"
import script from "./JoinPublicationCompleteAccount.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationCompleteAccount.vue?vue&type=script&lang=js"
export * from "./JoinPublicationCompleteAccount.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationCompleteAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/login-signup-page/join-publication/JoinPublicationCompleteAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf938ebc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf938ebc', __exports__)) {
    api.reload('cf938ebc', __exports__)
  }
  
  module.hot.accept("./JoinPublicationCompleteAccount.vue.js?vue&type=template&id=cf938ebc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublicationCompleteAccount.vue?vue&type=template&id=cf938ebc", () => {
    api.rerender('cf938ebc', render)
  })

}


export default __exports__